import type {
    ContactInfo,
    UserInfo,
    BankName,
    CustomerUpdateRequest,
    ApprovalResult,
    AgreementInfo,
    HasAgreementsResponse,
    BirthdayInfo,
} from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get, patch } from './request';

const SERVICE_PATH = 'rest/resource/profile';

export function getUserInfo(): Promise<UserInfo> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/userinfo`);
}

export function getUserAgreement(): Promise<AgreementInfo | undefined> {
    return get<AgreementInfo>(`${CONTEXT_PATH}/${SERVICE_PATH}/agreement`);
}

export function hasMultipleAgreements(): Promise<HasAgreementsResponse> {
    return get<HasAgreementsResponse>(`${CONTEXT_PATH}/${SERVICE_PATH}/has-multiple-agreements`);
}

export async function updateContactInformation(updateRequest: CustomerUpdateRequest): Promise<ApprovalResult> {
    return patch(`${CONTEXT_PATH}/${SERVICE_PATH}/contact`, updateRequest);
}

export async function getConfirmedStatus(): Promise<boolean> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/contact/confirmed-status`);
}

export async function getContactInfo(): Promise<ContactInfo> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/contact`);
}

export async function getBankName(): Promise<BankName> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/bankname`);
}

export async function getBirthDayInfo(): Promise<BirthdayInfo> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/birthday-info`);
}
